import React from 'react';
import { Document } from './components/document';
import './contestaward.css';

export class ContestAward extends React.Component {
    render() {
        return (
          <>
            <Document>
              <div className="contest-intro">
                <h2>Recognized Among Norway's Top Startups</h2>
                <p>
                    TigerCity.ai has been selected as one of the <strong>Top 50 startups</strong> in the 2025 edition of
                    <strong> 100 Pitches</strong> - Norway's largest pitching competition for investor-ready startups.
                </p>
                <p>
                    This competition, powered by DNB, Oslo Business Region, and Startuplab, recognizes the most 
                    promising Norwegian startups that demonstrate innovation, growth potential, and alignment with UN Sustainable 
                    Development Goals. 
                </p>
              </div>
            </Document>

            <figure className="contest-award">
              <img 
                 src="/images/100Pitches2025Top50.png" 
                 alt="100 Pitches 2025 Top 50 award badge recognizing TigerCity.ai as one of Norway's top 50 startups" 
                 style={{ width: '100%', height: 'auto', display: 'block' }} 
              />
            </figure>
          </>
        );
    }
}
